export default __webpack_public_path__ + "static/media/ds-desafios-logicos.98ac267e.png";